<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="hbaProfileDataSettings.MemberTypeCode.Visible" />{{
      'vertical.hba.member-type' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.MemberTypeCode.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="hbaProfileDataSettings.MembershipStatusCode.Visible" />{{
      'vertical.hba.membership-status' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.MembershipStatusCode.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="hbaProfileDataSettings.NumberOfUnitsCode.Visible" />{{
      'vertical.hba.number-of-units' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.NumberOfUnitsCode.LabelText"
  />
</div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" [(ngModel)]="hbaProfileDataSettings.DollarVolumeCode.Visible" />{{
      'vertical.hba.dollar-volume' | translate | titlecase
    }}</label
  >
  <input
    type="text"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.DollarVolumeCode.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" style="vertical-align: top" [(ngModel)]="hbaProfileDataSettings.PrimaryBusActivityCode.Visible" />
    {{ 'vertical.hba.primary-business-activity' | translate | titlecase }}</label
  >
  <input
    type="text"
    style="vertical-align: top"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.PrimaryBusActivityCode.LabelText"
  />
</div>
<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" style="vertical-align: top" [(ngModel)]="hbaProfileDataSettings.SecondaryBusActivityCode.Visible" />
    {{ 'vertical.hba.secondary-business-activity' | translate | titlecase }}</label
  >
  <input
    type="text"
    style="vertical-align: top"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.SecondaryBusActivityCode.LabelText"
  />
</div>
<div style="clear: both"></div>

<div class="col-sm-6 mct-flex mct-col mb-12">
  <label class="control-label">
    <input type="checkbox" style="vertical-align: top" [(ngModel)]="hbaProfileDataSettings.TertiaryBusActivityCode.Visible" />
    {{ 'vertical.hba.tertiary-business-activity' | translate | titlecase }}</label
  >
  <input
    type="text"
    style="vertical-align: top"
    placeholder="{{ 'common.optional-label-text' | translate | titlecase }}"
    class="pull-right"
    [(ngModel)]="hbaProfileDataSettings.TertiaryBusActivityCode.LabelText"
  />
</div>
<div style="clear: both"></div>
